var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(this.$store.getters.islogin === true)?_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('h3',[_vm._v("Verificando credenciales de "+_vm._s(this.$store.getters.nombreusuario)+"....")])]):_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('h3',[_vm._v("Cargando....")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21a9fe35","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Auth.vue
// module id = 86
// module chunks = 1